/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invite_SubmitInputs */

const cs_auth_invite_submit = /** @type {(inputs: Auth_Invite_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit heslo a pokračovat`)
};

const en_auth_invite_submit = /** @type {(inputs: Auth_Invite_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set password and continue`)
};

/**
* | output |
* | --- |
* | "Set password and continue" |
*
* @param {Auth_Invite_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_invite_submit = /** @type {((inputs?: Auth_Invite_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invite_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_invite_submit(inputs)
	return cs_auth_invite_submit(inputs)
});